export default {
  label: "Gestión de Activos",
  allAssets: "Todos los Activos",
  assetHistory: {
    button: "Historial del activo",
    close: "Cerrar historial",
    preview: "Vista previa",
    mockNotice:
      "Solo datos de ejemplo. Estos eventos no son el historial de este activo. No hay un backend de historial conectado.",
    changeLog: "Historial de cambios",
    newestFirst: "Más recientes primero",
    edit: "Activo editado",
    fieldsChanged: "campos modificados",
    expandChanges: "Mostrar cambios de campos",
    collapseChanges: "Ocultar cambios de campos",
    initialUpload: "Carga inicial",
    locationValuesHidden: "No se muestran los valores de ubicación.",
    hiddenUser: "No se muestra",
    privacyNotice:
      "Solo los operadores de plataforma ven al usuario que cargó el activo. Para cambios posteriores, los operadores de activos solo ven usuarios de su organización.",
    empty: "No hay entradas en el historial.",
    loading: "Cargando historial",
    loadError: "No se pudo cargar el historial. Vuelve a intentarlo o comprueba tus permisos de acceso.",
    retry: "Reintentar",
    changedOnly: "Modificado; los valores no se registran.",
    labelsUnavailable: "No se pudieron cargar algunos nombres. Se muestran los identificadores disponibles.",
    columns: {
      timestamp: "Fecha y hora",
      field: "Campo / evento",
      before: "Valor anterior",
      after: "Valor nuevo",
      user: "Usuario",
      tenant: "Organización",
    },
    fields: {
      creation: "Activo cargado",
      organisation: "Organización",
      approval: "Estado de aprobación",
      project: "Proyecto",
      location: "Posición del activo",
      contact: "Contacto de emergencia",
      directory: "Contacto",
      note: "Nota",
      serialNo: "Identificador del activo",
      comment: "Comentario",
      commissioningDate: "Puesta en servicio",
      constructionDate: "Construcción",
      assetModel: "Modelo del activo",
      parentAsset: "Activo superior",
      billingAddress: "Dirección de facturación",
      streetAccessPoint: "Punto de acceso",
      accessRoutes: "Ruta de acceso",
      locationOther: "Ubicación",
      attribute: "Atributo del activo",
      media: "Medios y archivos",
      safetyNotes: "Información de seguridad del producto",
      other: "Cambio de campo",
    },
    directoryFields: {
      Name: "Nombre",
      FirstName: "Nombre de pila",
      LastName: "Apellido",
      Email: "Correo electrónico",
      Phone: "Teléfono",
      Note: "Nota",
    },
    billingAddressFields: {
      Name: "Nombre",
      Email: "Correo electrónico",
      StreetAndNumber: "Calle y número",
      Zipcode: "Código postal",
      City: "Ciudad",
      Country: "País",
      Note: "Nota",
      PurchaseOrderNumber: "Número de Orden de Compra",
    },
    organisations: {
      current: "Organización de ejemplo",
      previous: "Organización anterior de ejemplo",
      platform: "Plataforma de ejemplo",
    },
    actors: {
      current: "Operador de ejemplo",
      previous: "Operador anterior de ejemplo",
      platform: "Operador de plataforma de ejemplo",
    },
    values: {
      previousOrganisation: "Organización anterior de ejemplo",
      currentOrganisation: "Organización de ejemplo",
      pending: "Pendiente",
      approved: "Aprobado",
      projectBefore: "Parque eólico de ejemplo Norte",
      projectAfter: "Parque eólico de ejemplo Sur",
      contactBefore: "Contacto de ejemplo A",
      contactAfter: "Contacto de ejemplo B",
      noteAfter: "Información de mantenimiento de ejemplo",
    },
  },
  userAccessReport: {
    button: "Descargar informe de acceso de usuarios",
    title: "Descargar informe de acceso de usuarios",
    description: "Elige un rango de fechas opcional. Si dejas ambos campos vacíos, se usará el trimestre actual.",
    startDate: "Fecha de inicio",
    endDate: "Fecha de finalización",
    submit: "Descargar",
    downloading: "Descargando...",
    cancel: "Cancelar",
    invalidRangeError: "La fecha de inicio debe ser anterior a la fecha de finalización.",
    notAuthorizedError: "No tienes autorización para descargar este informe.",
    genericError: "No se pudo generar el informe. Inténtalo de nuevo.",
  },
  batchEdit: {
    button: "Edición por lotes",
    title: "Edición por lotes",
    selectedAssets: "Activos seleccionados",
    emptyFieldsHint: "Los campos vacíos no se sobrescribirán.",
    organisation: "Organización",
    organisationDisabledHint: "Solo los operadores de la plataforma pueden cambiar la organización.",
    billingAddress: "Dirección de facturación",
    contacts: "Contactos de emergencia",
    contactsReplaceHint: "Los contactos seleccionados reemplazan los contactos existentes de los activos.",
    attachment: "Archivo adjunto PDF",
    attachmentColumn: "PDF",
    attachmentAddHint: "El PDF se añade a los archivos existentes de los activos.",
    attachmentFileNameRequired: "Introduzca un nombre de archivo.",
    save: "Guardar cambios",
    resultTitle: "Resultado de la edición por lotes",
    resultSummary: "{success} de {total} activos actualizados correctamente.",
    statusSuccess: "Correcto",
    statusFailed: "Fallido",
    statusSkipped: "Omitido",
    statusUnchanged: "Sin cambios",
    skippedHint: "No se ejecutó porque un paso anterior falló para este activo.",
    failedHint: "No se pudo guardar el cambio.",
    contactsNotRemovedHint: "Se añadieron los nuevos contactos, pero no se pudieron eliminar los contactos anteriores.",
    retryFailed: "Reintentar fallidos",
  },
  tabs: {
    assets: {
      deleteAsset: "Eliminar Activo",
      pendingAssets: "Activos Pendientes",
      deleteAssetMessagePart1: "Estás eliminando el Activo",
      deleteAssetMessagePart2: "de la base de datos. ¿Estás seguro de que quieres continuar?",
      deleteAssetMessagePluralPart1: "Estás eliminando los Activos",
      allAssetView: "Ver todos los Activos",
      projectView: "Vista de Proyecto",
      label: "Lista de Activos",
      asset: "Activo",
      labelForProjectAndAssetView: "Activos y Proyectos",
      generalInfos: "Información General",
      note: "Nota",
    },
    importAssets: {
      importSuccessTitle: "Activos importados exitosamente",
      importSuccessMessage:
        "Los 3 activos fueron cargados exitosamente. Para completar la importación, ve a la sección 'Activos Pendientes' donde puedes finalizar el proceso asignando rutas, subiendo fotos y verificando los datos escaneados para asegurar la precisión.",
      importNotPossibleTitle: "Los activos no pudieron ser importados",
      importNotPossibleMessagePart1:
        "La importación de activos falló. Se encontraron problemas en las siguientes celdas: ",
      importNotPossibleMessagePart2:
        "Por favor revisa el archivo cargado nuevamente e inténtalo de nuevo. Los problemas comunes son:",
      importNotPossibleMessagePart3: "Activos duplicados (dos o más activos con el mismo número de serie)",
      importNotPossibleMessagePart4: "El activo ya existe",
      importNotPossibleMessagePart5: "Formato incorrecto de datos requeridos",
      importNotPossibleMessagePart6: "Datos requeridos faltantes",
    },
    assetGroups: {
      label: "Grupos de Activos",
      list: "Lista de Activos",
      activities: "Actividades",
      newAssetGroup: "Nuevo Grupo de Activos",
      sort: {
        labelAsc: "ASC",
        labelDesc: "DESC",
      },
    },
    assetTags: {
      updateTags: "Actualizar Etiquetas",
    },
    assetTypes: {
      label: "Tipos de Activos",
      deleteAssetType: "Eliminar Tipo de Activo",
      deleteAssetTypeMessage: "¿Estás seguro de que quieres eliminar este tipo de activo?",
      newAssetType: "Nuevo Tipo de Activo",
      resetToDefaultValue: "Restablecer al valor predeterminado",
      deleteAssetTypeMessagePart1: "Este tipo de activo no puede ser eliminado ya que está asociado con ",
      deleteAssetTypeMessagePart2:
        "instancias de Modelo(s). Para que un tipo de activo sea eliminado, no pueden existir Modelos de activos.",
      deleteAssetModelErrorMessage: "¡Asegúrate de eliminar solo Modelos que no tengan Activos asignados!",
      deleteAssetModelSuccessMessage: "Has eliminado exitosamente el/los Modelo(s) de Activo",
      deleteAssetModelWarningMessage:
        " No puedes eliminar Modelos de Activos si tienen Activo(s) asignados a ellos. Activo(s) que están asignados al/los Modelo(s) de Activo",
      deleteImage: {
        modalTitle: "Eliminar Imagen",
        modalMessage: "¿Estás seguro de que quieres eliminar esta imagen?",
      },
    },
    assetModels: {
      deleteAssetModel: "Eliminar Modelo de Activo",
      deleteAssetModelMessage: "¿Estás seguro de que quieres eliminar este/estos Modelo(s) de Activo?",
      deleteAssetModelTitle: "Eliminar Modelo de Activo",
      deleteNotPossibleMessagePart1: "Este modelo de activo no puede ser eliminado ya que está asociado con ",
      deleteNotPossibleMessagePart2:
        "instancias de Modelo(s). Para que un modelo de activo sea eliminado, no pueden existir activos.",
      deleteNotPossibleBecauseTheseModelsHaveAssets1:
        "Los modelos de activos seleccionados no pueden ser eliminados porque los siguientes modelos tienen activos asignados a ellos:",
      deleteNotPossibleBecauseTheseModelsHaveAssets2:
        "Para eliminar modelos de activos, no deben tener activos asignados.",
    },
    assetDetails: {
      label: "Detalles del activo",
      assetDetailsPageTabs: {
        position: "Posición",
        attributes: "Atributos",
        addAnotherModel: "Agregar Otro Modelo",
        photos: "Fotos",
        assetPictures: "Imágenes del Activo",
        mediaAndFiles: "Medios y Archivos",
        fileName: "Nombre del Archivo",
        selectFile: "Seleccionar Archivo",
        fileSize: "Tamaño del Archivo",
        uploadedOn: "Subido el [MB]",
        otherDocuments: "Otros Documentos",
        comments: "Comentarios",
        changes: "Cambios",
        deleteFilesMessage: "¿Estás seguro de que quieres eliminar los archivos adjuntos seleccionados?",
        deleteFileMessage: "¿Estás seguro de que quieres eliminar este archivo adjunto?",
      },
    },
    assetAttributeFieldsAndSets: {
      label: "Campos y Conjuntos de Atributos",
      deleteMessage:
        "Eliminar este conjunto afectará a todos los tipos de activos que lo hayan seleccionado para mostrar valores de atributos de sus instancias. ¿Estás seguro de que quieres eliminarlo?",
      deleteAssetAttributeSets: "eliminar Conjunto de Atributos de Activo",
      attributes: "Atributos",
      attribute: "Atributo",
      noAttributes: "Sin Atributos",
    },
    AssetAttributes: {
      createAssetAttribute: {
        successMessage: "Atributo de Activo creado exitosamente",
        errorMessage: "Error al crear Atributo de Activo",
      },
      editAssetAttribute: {
        successMessage: "Atributo de Activo editado exitosamente",
        errorMessage: "Error al editar Atributo de Activo",
      },
    },
    AssetAttributeSets: {
      label: "Conjuntos de Atributos",
    },
    assetNewEntry: {
      label: "Nuevas Entradas",
      newAssets: "Nuevos Activos",
      dateTime: "Fecha y Hora",
    },
    projects: {
      label: "Proyectos",
    },
    errorCodes: {
      noError: "No ocurrió ningún error",
      fieldValidationError:
        "Algunos campos contienen datos inválidos. Por favor verifica los siguientes campos e inténtalo de nuevo.",
      csvParsingError:
        "El archivo no pudo ser leído correctamente. Asegúrate de que el archivo esté en el formato correcto y no contenga datos corruptos.",
      assetAlreadyExistsError:
        "Ya existe un activo con el mismo número de serie en el sistema. Asegúrate de que el número de serie sea único e inténtalo de nuevo.",
      manufacturerMissing:
        "Falta información del fabricante. Por favor completa todos los campos requeridos e inténtalo de nuevo.",
      modelMissing:
        "Falta información del modelo. Por favor completa todos los campos requeridos e inténtalo de nuevo.",
      unknownError:
        "Ocurrió un error desconocido. Por favor inténtalo de nuevo o contacta al administrador del sistema si el problema persiste.",
    },
    safetyNotes: {
      label: "Notas de Seguridad",
      safetyNoteDetails: "Detalles de la Nota de Seguridad",
      newSafetyNote: "Nueva Nota de Seguridad",
      updateSafetyNote: "Actualizar Nota de Seguridad",
      deleteSafetyNoteMessage: "¿Estás seguro de que quieres eliminar esta nota de seguridad?",
      deleteSafetyNote: "Eliminar Nota de Seguridad",
    },
  },
};
